export default "__VITE_ASSET__E6AvfzVg__"